import React from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./styles.scss";

const LoanDetailsCard = ({
  loanHeading,
  loanDescription,
  detailCardHeading,
  cardData,
}) => {
  const location = useLocation();
  const { t } = useTranslation();
  const { pathname } = location;
  const routeName = pathname.split("/")[1];

  return (
    <div className="loan-details-card">
      <p className="loan-details-card-heading">{loanHeading}</p>
      <p className="loan-details-card-description">{loanDescription}</p>
      <div className="details-card">
        <p className="details-card-heading">{detailCardHeading}</p>
        <div className="details-card-item-container">
          {cardData?.map((item) => {
            return (
              <div className="details-card-item">
                <p className="card-item-value">
                  {item?.isTranslate
                    ? t(`${routeName}.${item.value}`)
                    : item.value}
                </p>
                <p className="card-item-label">
                  {t(`${routeName}.${item.label}`)}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default LoanDetailsCard;
